import { Box, Typography } from '@mui/material';
import { COLUMN_INFO_BOX_STYLE, COLUMN_INFO_TYPOGRAPHY_STYLE } from '../../../../style';

const ColumnInfo = ({ columnInfoMap }) => (
  <Box sx={COLUMN_INFO_BOX_STYLE}>
    {Object.entries(columnInfoMap)
      .sort(([, a], [, b]) => a.localeCompare(b))
      .map(([id, text]) => (
      <Typography key={id} sx={COLUMN_INFO_TYPOGRAPHY_STYLE}>
        <strong>{id} = {text}</strong>
      </Typography>
    ))}
  </Box>
);

export default ColumnInfo;
